import React, { useState, useEffect } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

// Statische Placeholder-News als Showcase-Design (O2 Blaues Netz, etc.)
const PLACEHOLDER_NEWS = [
  {
    id: 1,
    title: 'O2 Mobile 5G Ausbau erreicht neuen Meilenstein',
    date: '15. März 2026',
    category: 'Netz',
    imageUrl: 'https://images.unsplash.com/photo-1544465544-1b71aee9dfa3?q=80&w=800&auto=format&fit=crop',
    excerpt: 'Das 5G Netz von Telefónica ist nun in weiteren 150 ländlichen Kommunen verfügbar...'
  },
  {
    id: 2,
    title: 'Neue Hardware-Bundle Aktion: iPhone 17',
    date: '10. März 2026',
    category: 'Angebote',
    imageUrl: 'https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?q=80&w=800&auto=format&fit=crop',
    excerpt: 'Ab Montag startet die neue Promo in den Shops: iPhone 17 Pro für 1€ Zuzahlung.'
  },
  {
    id: 3,
    title: 'WKZ Zuschüsse für Q2 erhöht',
    date: '5. März 2026',
    category: 'Agentur',
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=800&auto=format&fit=crop',
    excerpt: 'Gute Nachrichten für Handelspartner: Die Werbekostenzuschüsse steigen um 15%.'
  }
];

export function NewsFeedRender({ node, isLiveMode }) {
  const content = node.content || {};
  const maxItems = parseInt(content.maxItems, 10) || 3;
  const columns = parseInt(content.columns, 10) || 3;
  
  const displayNews = PLACEHOLDER_NEWS.slice(0, maxItems);

  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto' }} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${columns} gap-6`}>
      {displayNews.map(news => (
        <div key={news.id} style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.05)',
          borderRadius: '12px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          transition: 'all 0.3s ease',
        }}>
          {/* Bild */}
          <div style={{ height: '180px', width: '100%', overflow: 'hidden', position: 'relative' }}>
            <img src={news.imageUrl} alt={news.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <div style={{
              position: 'absolute', top: '10px', left: '10px',
              background: 'var(--tef-primary, #00A9E0)', color: '#fff',
              fontSize: '11px', fontWeight: 'bold', padding: '4px 8px', borderRadius: '4px'
            }}>
              {news.category}
            </div>
          </div>
          
          {/* Inhalt */}
          <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '8px' }}>{news.date}</div>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#f8fafc', marginBottom: '10px', lineHeight: '1.3' }}>{news.title}</h3>
            <p style={{ fontSize: '14px', color: '#cbd5e1', lineHeight: '1.5', flex: 1 }}>{news.excerpt}</p>
            
            <button style={{
              marginTop: '15px', padding: '8px 16px', background: 'transparent',
              border: '1px solid var(--tef-primary, #00A9E0)', color: 'var(--tef-primary, #00A9E0)',
              borderRadius: '6px', cursor: 'pointer', fontWeight: '600', width: 'fit-content'
            }}>
              Weiterlesen
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

registry.register('NewsFeed', {
  label: 'TEF News Feed',
  icon: '📰', 
  category: 'tef',
  component: NewsFeedRender,
  
  defaultProps: {
    content: {
      maxItems: '3',
      columns: '3'
    },
    style: {
      desktop: {
        padding: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'News Einstellungen',
          fields: [
            { name: 'content.maxItems', label: 'Anzahl Artikel (max 3 derzeit)', type: 'select', options: ['1', '2', '3'] },
            { name: 'content.columns', label: 'Spaltenanzahl auf Desktop', type: 'select', options: ['1', '2', '3'] }
          ]
        }
      ]
    }
  ]
});
